import React from 'react';
import { __ } from '@wordpress/i18n';

// store
import { useStoreValue } from '../../store';

// components
import DomandeTablePreInstructorAsync from '../DashboardPreInstructor/components/DomandeTablePreInstructorAsync';

const DomandeArchivePreInstructor = () => {
    const userData = useStoreValue('userData');

    return (
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Archivio domande', 'gepafin')}</h1>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <h2>{__('Domande completate', 'gepafin')}</h2>
                <DomandeTablePreInstructorAsync statuses={['CLOSE']} applicationStatuses={['APPROVED', 'REJECTED', 'TECHNICAL_EVALUATION_REJECTED']} userId={userData.id}/>
            </div>
        </div>
    )
}

export default DomandeArchivePreInstructor;